exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.player[data-v-7a476d08] {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.control[data-v-7a476d08] {\n}\n.seekbar[data-v-7a476d08] {\n  flex-grow: 1;\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.time[data-v-7a476d08] {\n  font-family: monospace, monospace;\n  margin-right: 8px;\n  color: #323232;\n  font-size: 12px;\n}\n.play-button[data-v-7a476d08] {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  margin: 5px;\n}\n", ""]);

// exports
